import getParams from '../Utils/getParams'
import { getSubInvoices } from '../../../../../HttpRequests/subInvoices'
import { setSubInvoices } from '../State/subInvoices'
import { startFetching, finishFetching } from '../State/fetching'
import { setPagination } from '../State/pagination'
import handleException from '../../../../../Core/Helpers/handleException'

export default () => async (dispatch, getState) => {

  const state = getState()

  const { pagination } = getState().screens.Subbies.SubInvoices

  const params = getParams(state)

  params.include = [
    'subcontractor',
    'user',
  ].join(',')

  params['page[number]'] = pagination.pageNumber
  params['page[size]'] = pagination.pageSize

  dispatch(startFetching())

  try {

    const response = await getSubInvoices({ params })

    dispatch(setSubInvoices(response.data.rows))

    dispatch(setPagination({
      pageNumber: response.data.pagination.current_page,
      pageSize: response.data.pagination.per_page,
      total: response.data.pagination.total,
    }))

  } catch (error) {

    handleException(error)

  } finally {

    dispatch(finishFetching())

  }

}
